// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33WOg","title":"styles_title__4l31e"};